import { apiBaseQuery } from '@cognitranlimited/itis-web';
import queryString from 'query-string';
import { createApi } from '@reduxjs/toolkit/query/react';
export var gieLinksModuleApi = createApi({
    reducerPath: "gieLinksApi",
    baseQuery: apiBaseQuery(),
    tagTypes: ['GieLinks'],
    endpoints: function (builder) { return ({
        getDocumentProcedureTree: builder.query({
            query: function (_a) {
                var documentId = _a.documentId, vehicle = _a.vehicle, query = _a.query, parameters = _a.parameters;
                return queryString.stringifyUrl({
                    url: "".concat(getVehicleApiRoot(vehicle), "/documents/").concat(documentId, "/tree"),
                    query: { query: query, parameters: parameters }
                }, {
                    skipEmptyString: true
                });
            },
            extraOptions: {
                timeout: 30000
            }
        })
    }); }
});
export function getVehicleApiRoot(vehicle) {
    if (vehicle === null) {
        return '';
    }
    switch (vehicle.ref) {
        case 'vin':
            return "/vehicles/".concat(vehicle.vin);
        case 'product': {
            var path = "/product-variants/".concat(vehicle.productVariantId);
            if (vehicle.year) {
                path += "/".concat(vehicle.year);
            }
            return path;
        }
        default:
            throw new Error('Invalid vehicle reference: ' + JSON.stringify(vehicle));
    }
}
export var useGetDocumentProcedureTreeQuery = gieLinksModuleApi.useGetDocumentProcedureTreeQuery;
